import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { textEllipsis } from '@ecp/common/src/style/theme/defaultStyled';
import CollapseArrow from '@ecp/common/src/assets/icon/collapse_arrow.svg';

import { FlexBox, FlexBoxButtonSpaceBetween, FlexBoxSpaceBetween } from '../../../layouts/flex/styled';
//import { theme } from '../../../style/theme/default';
import { stateClassNames } from './DropdownUnstyled';

const DefaultLabelRoot = styled(FlexBoxButtonSpaceBetween)`
  width: 100%;
  height: 40px;
  line-height: 28px;
  padding: 0 14px;
  ${(props) => props.theme.component.dropdown.defaultBorder}
  gap: 4px;
  text-align: left;
  color: ${(props) => props.theme.color.text.basic};
  font-size: ${(props) => props.theme.component.dropdown.fontSize};

  &.${stateClassNames.disabled} {
    background-color: ${(props) => props.theme.color.background.disabled};
  }

  &.${stateClassNames.open} {
    border-color: ${(props) => props.theme.color.line.selected};
  }

  &.${stateClassNames.error} {
    border-color: ${(props) => props.theme.color.line.error};
  }
`;

const DivLabelRoot = styled(FlexBoxSpaceBetween)`
  width: 100%;
  height: 40px;
  line-height: 28px;
  padding: 0 14px;
  ${(props) => props.theme.component.dropdown.defaultBorder}
  gap: 4px;

  &.${stateClassNames.disabled} {
    background-color: ${(props) => props.theme.color.background.disabled};
  }

  &.${stateClassNames.open} {
    border-color: ${(props) => props.theme.color.line.selected};
  }

  &.${stateClassNames.error} {
    border-color: ${(props) => props.theme.color.line.error};
  }
`;

const DefaultLabelText = styled.div`
  ${textEllipsis};
  width: 100%;

  &.${stateClassNames.notSelected} {
    font-size: ${(props) => props.theme.font.size.basic};
    color: ${(props) => props.theme.color.text.placeholder};
  }
`;

const DefaultLabelIcon = styled.div`
  width: 18px;
  height: 18px;
  background-image: url(${CollapseArrow});
  background-repeat: no-repeat;
  background-position: center;

  &.${stateClassNames.disabled} {
    color: #bfbfbf;
  }

  &.${stateClassNames.open} {
    transform: rotate(180deg);
  }
`;

export const StyledDefaultLabel = ({ item, placeholder, className }) => {
  return (
    <DefaultLabelRoot className={className}>
      <DefaultLabelText className={className}>{item?.label || placeholder}</DefaultLabelText>
      <DefaultLabelIcon className={className} />
    </DefaultLabelRoot>
  );
};
StyledDefaultLabel.displayName = 'StyledDefaultLabel';
StyledDefaultLabel.propTypes = {
  item: PropTypes.object,
  className: PropTypes.string,
  placeholder: PropTypes.string,
};

export const StyledDivLabel = ({ item, placeholder, className }) => {
  return (
    <DivLabelRoot className={className}>
      <DefaultLabelText className={className}>{item?.label || placeholder}</DefaultLabelText>
      <DefaultLabelIcon className={className} />
    </DivLabelRoot>
  );
};
StyledDivLabel.displayName = 'StyledDivLabel';
StyledDivLabel.propTypes = {
  item: PropTypes.object,
  className: PropTypes.string,
  placeholder: PropTypes.string,
};

export const DropdownItemWrapper = styled(FlexBox)`
  align-items: center;
  height: 40px;
  line-height: 28px;
  padding: 0 14px;

  &:hover {
    background-color: ${(props) => props.theme.color.background.sub};
  }

  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  &[disabled] {
    color: ${(props) => props.theme.color.secondary};
  }
`;

export const DropdownItem = styled.div`
  ${textEllipsis};
  width: 100%;
`;

export const StyledDefaultItem = ({ label, disabled }) => (
  <DropdownItemWrapper disabled={disabled}>
    <DropdownItem>{label}</DropdownItem>
  </DropdownItemWrapper>
);

StyledDefaultItem.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
};
